import React, { useState } from "react";
import { Popover } from "antd";
import { FaDownload } from "react-icons/fa";

const COLOR_BACKGROUND = {
  unmarked: "#1a1a1a",
  red: "#E23B3B",
  yellow: "#F2C200",
  green: "#2E8B57",
};

const OPTIONS = ["red", "yellow", "green"];

// Bolinha clicável de status de estudo (preta+"?" = não marcado). Clique
// abre um mini seletor inline (vermelho/amarelo/verde) — reaproveita a
// mesma paleta do popover antigo (modal-revision-color.js), mas como
// componente próprio, sem depender da cadeia de modais antiga.
//
// Regra do cliente (2026-07-22): só dá pra marcar uma cor depois do 1º
// download do caderno — antes disso a bolinha (só no estado "não
// marcado") vira um ícone de download, sem o seletor de cor. Clicar
// nela, nesse estado, dispara o próprio download (mesma ação do botão
// "Download" da linha). Uma vez marcada, a cor sempre fica editável
// normalmente, mesmo que o "downloaded" mude depois. Vale igual pra
// premium (2026-07-27: premium também passou a ter downloadedAt
// rastreado no backend — ver ProductDownloadService, era null sempre
// antes, por isso premium ficava fora do gate).
const RevisionColorDot = ({
  color = "unmarked",
  onSelect,
  disabled,
  downloaded = true,
  onDownloadClick,
}) => {
  const [open, setOpen] = useState(false);

  const handlePick = (newColor) => {
    setOpen(false);
    if (newColor !== color) onSelect(newColor);
  };

  const needsDownloadFirst = color === "unmarked" && !downloaded;

  if (needsDownloadFirst) {
    return (
      <button
        type="button"
        disabled={disabled}
        className="revision-color-dot revision-color-dot-download"
        title="Baixe o caderno para poder marcar a cor"
        onClick={onDownloadClick}
      >
        <FaDownload size={11} />
      </button>
    );
  }

  return (
    <Popover
      trigger="click"
      open={open && !disabled}
      onOpenChange={(next) => !disabled && setOpen(next)}
      content={
        <div className="revision-color-options">
          {OPTIONS.map((opt) => (
            <button
              key={opt}
              type="button"
              title={opt}
              className={`revision-color-swatch revision-color-swatch-${opt}`}
              onClick={() => handlePick(opt)}
            />
          ))}
        </div>
      }
    >
      <button
        type="button"
        disabled={disabled}
        className="revision-color-dot"
        style={{ backgroundColor: COLOR_BACKGROUND[color] || COLOR_BACKGROUND.unmarked }}
      >
        {color === "unmarked" && <span>?</span>}
      </button>
    </Popover>
  );
};

export default RevisionColorDot;
